import { render } from "./ManualSearchModal.vue?vue&type=template&id=12d34492"
import script from "./ManualSearchModal.vue?vue&type=script&lang=js"
export * from "./ManualSearchModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/4schemplus/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__